import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex items-center mb-6 text-gray-700" }
const _hoisted_2 = { class: "font-medium" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "mr-5 mt-1 bg-gray-200 rounded-full p-2 h-10" }
const _hoisted_5 = { class: "flex flex-col gap-y-2" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = ["checked"]
const _hoisted_10 = {
  key: 0,
  class: "mt-3 flex items-center space-x-2"
}
const _hoisted_11 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "mr-5 mt-1 bg-gray-200 rounded-full p-2 h-10" }
const _hoisted_14 = { class: "flex flex-col gap-y-2" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = ["checked"]
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = ["checked"]
const _hoisted_19 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "mr-5 mt-1 bg-gray-200 rounded-full p-2 h-10" }
const _hoisted_22 = { class: "flex flex-col gap-y-2" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = ["checked"]
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = ["checked"]
const _hoisted_27 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "mr-5 mt-1 bg-gray-200 rounded-full p-2 h-10" }
const _hoisted_30 = { class: "flex flex-col gap-y-2" }
const _hoisted_31 = { class: "flex items-center" }
const _hoisted_32 = ["checked"]
const _hoisted_33 = { class: "flex items-center" }
const _hoisted_34 = ["checked"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "mt-3 flex items-center gap-x-2" }
const _hoisted_37 = {
  key: 0,
  class: "mt-3 flex items-center gap-2"
}
const _hoisted_38 = { class: "flex items-center gap-5" }
const _hoisted_39 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "flex items-center gap-5" }
const _hoisted_42 = { class: "flex w-full justify-end gap-3" }
const _hoisted_43 = { class: "flex w-full justify-between" }
const _hoisted_44 = { class: "flex gap-3" }
const _hoisted_45 = { class: "flex w-full justify-between" }
const _hoisted_46 = { class: "flex gap-3" }
const _hoisted_47 = {
  key: 1,
  class: "flex items-center mt-6 text-sm"
}
const _hoisted_48 = { class: "flex w-full justify-between gap-2" }
const _hoisted_49 = { class: "flex w-full justify-between gap-2" }
const _hoisted_50 = {
  key: 0,
  class: "flex gap-3"
}
const _hoisted_51 = {
  key: 1,
  class: "flex gap-3"
}
const _hoisted_52 = { class: "slot-calendar flex flex-wrap" }
const _hoisted_53 = { class: "slot-calendar__month w-full max-w-[21rem] sm:w-[21rem] flex-none" }
const _hoisted_54 = { class: "flex items-center" }
const _hoisted_55 = { class: "mt-2 grid grid-cols-7 text-sm" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "slot-calendar__day w-full min-w-0 mt-12" }
const _hoisted_58 = { class: "text-base font-semibold leading-6 text-gray-900" }
const _hoisted_59 = { class: "w-full mt-4 flex flex-col gap-y-3" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 1,
  class: "block mb-1 font-manrope uppercase tracking-wider text-sm text-gray-900 border-b px-3 py-1.5 bg-gray-50 break-words"
}
const _hoisted_62 = { class: "px-3 py-1.5 flex gap-1.5 mt-1" }
const _hoisted_63 = {
  key: 0,
  class: "px-2 py-0.5 text-xs font-medium rounded-md text-green-700 bg-green-100 border border-green-700"
}
const _hoisted_64 = {
  key: 1,
  class: "px-2 py-0.5 text-xs font-medium rounded-md text-red-700 bg-red-100 border border-red-700"
}
const _hoisted_65 = {
  key: 1,
  class: "px-2 py-0.5 text-xs font-medium rounded-md text-white bg-yellow-800"
}
const _hoisted_66 = {
  key: 0,
  class: "px-2 py-0.5 text-xs font-medium rounded-md text-yellow-700 bg-yellow-00 border border-yellow-700"
}
const _hoisted_67 = {
  key: 1,
  class: "px-2 py-0.5 text-xs font-medium rounded-md text-green-700 bg-green-100 border border-green-700"
}
const _hoisted_68 = {
  key: 2,
  class: "px-2 py-0.5 text-xs font-medium rounded-md text-red-700 bg-red-100 border border-red-700"
}
const _hoisted_69 = { class: "sm:flex justify-between items-end" }
const _hoisted_70 = { class: "px-3 py-1.5 space-y-2" }
const _hoisted_71 = { class: "text-md text-gray-900" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = {
  key: 1,
  class: "flex flex-wrap gap-2"
}

import {
  CalendarDaysIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ClockIcon,
  CubeIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  LockOpenIcon,
  XCircleIcon
} from '@heroicons/vue/24/outline'
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { DatePicker } from 'v-calendar'

import { useFulfillmentWizardAccess } from '@/composables/useFulfillmentWizardAccess'
import { useToast } from '@/composables/useToast'
import { WIZARD_PATH } from '@/config/fulfillmentWizardSteps'
import { dateObjectToServerDay, serverDayToDateObject } from '@/helpers/dates'
import { affectedDropsFrom } from '@/helpers/dropImpact'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'
import DropImpactWarningModal from './DropImpactWarningModal.vue'
import NeueButton from './NeueButton.vue'


export default {
  __name: 'FulfillmentSlotCalendar',
  props: {
  slots: { type: Function, required: true },
  fulfillmentMethod: { type: Object, default: null },
  store: { type: Object, default: null },
  externalDays: { type: Array, default: null },
  selectedDay: { type: Date, default: null },
  editable: { type: Boolean, default: true }
},
  emits: ['getSlots', 'update:externalDays'],
  setup(__props, { emit: __emit }) {

const wizardEnabled = useFulfillmentWizardAccess()

const props = __props
const emit = __emit
const store = useStore()
const { showToast } = useToast()

const modal = ref({ open: false, delete: false, save: false, method: false, closure: false, clone: null })
const selectedDay = ref(new Date())
// Held as one value per modal open. Minting `new Date()` inline in the template
// handed every picker a fresh object on every render, so any edit invalidated
// v-calendar's attribute chain on calendars that were mid-unmount — where it
// has already emptied its pages and reading the first day's index throws.
const earliestSelectable = ref(new Date())

watch(
  () => props.selectedDay,
  () => {
    selectedDay.value = props.selectedDay
  }
)

const raiseArrivalEndTo = start => {
  const { arrival } = modal.value
  if (start && (!arrival.end || arrival.end < start)) arrival.end = start
}

const enableArrivalRange = () => {
  modal.value.pickers.arrival.end = true
  raiseArrivalEndTo(modal.value.arrival.start)
}

const raiseHardCutoffTo = display => {
  const { end } = modal.value.ordering
  if (display && (!end.actual || end.actual < display)) end.actual = display
}

// The hard cutoff the slot arrived with is the one derived from the arrival
// time, so switching the grace period on has to start from the cutoff the
// merchant just set above rather than whatever was left behind.
const defaultHardCutoffToDisplayCutoff = enabled => {
  if (enabled) modal.value.ordering.end.actual = modal.value.ordering.end.display
}

const shortFormat = x =>
  new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour12: true,
    hour: 'numeric',
    minute: '2-digit'
  }).format(new Date(x))
const dateFormat = x =>
  new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric'
  }).format(new Date(x))
const timeFormat = x =>
  new Intl.DateTimeFormat('en-US', {
    hour12: true,
    hour: 'numeric',
    minute: '2-digit'
  }).format(new Date(x))
const calendarFormat = new Intl.DateTimeFormat('en-US', {
  day: 'numeric'
}).format
const monthDayFormat = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  day: 'numeric'
}).format
const monthFormat = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  year: 'numeric'
}).format
const isSelectedMonth = date =>
  selectedDay.value.getMonth() === date.getMonth() && selectedDay.value.getFullYear() === date.getFullYear()
const isSelectedDay = date =>
  selectedDay.value.getDate() === date.getDate() &&
  selectedDay.value.getMonth() === date.getMonth() &&
  selectedDay.value.getFullYear() === date.getFullYear()
const isCurrentDay = date =>
  new Date().getDate() === date.getDate() &&
  new Date().getMonth() === date.getMonth() &&
  new Date().getFullYear() === date.getFullYear()
const plusDays = (date, days) => {
  const d = new Date(date.getTime())
  d.setDate(date.getDate() + days)
  return d
}
const plusMonths = (date, months) => {
  const d = new Date(date.getTime())
  d.setMonth(date.getMonth() + months)
  return d
}

const browserTZ = computed(() =>
  new Date().toLocaleDateString(undefined, { day: '2-digit', timeZoneName: 'short' }).substring(4)
)

const days = computed(() => {
  const startOfMonth = new Date(selectedDay.value.getFullYear(), selectedDay.value.getMonth(), 1)
  const endOfMonth = new Date(selectedDay.value.getFullYear(), selectedDay.value.getMonth() + 1, 0)

  const start = plusDays(startOfMonth, -startOfMonth.getDay())
  const end = plusDays(endOfMonth, 6 - endOfMonth.getDay())

  const days = []
  for (let i = 0; plusDays(start, i) <= end; i++) {
    days.push(plusDays(start, i))
  }
  return days
})

const dayClasses = day => {
  const classes = []
  if (isCurrentDay(day)) {
    classes.push('underline', 'decoration-2', 'underline-offset-2')
  }

  if (isSelectedDay(day)) {
    classes.push('font-semibold', 'text-white')
    if (externalDayEnabled(day)) {
      classes.push('bg-blue-600')
    } else {
      classes.push('bg-gray-900')
    }
    if (dayClosed(day)) {
      classes.push('border-2', 'border-yellow-800')
    } else if (arrivalSlots(day).length && !props.externalDays) {
      classes.push('border-2')
      if (
        arrivalSlots(day).some(
          x =>
            new Date() > new Date(x.attributes.begin_taking_orders) && new Date() < new Date(x.attributes.actual_cutoff)
        )
      ) {
        if (
          arrivalSlots(day).some(
            x => (x.attributes.limit_quantity && x.attributes.quantity_left) || !x.attributes.limit_quantity
          )
        ) {
          classes.push('border-green-500')
        } else {
          classes.push('border-red-500')
        }
      } else if (arrivalSlots(day).some(x => new Date() < new Date(x.attributes.begin_taking_orders))) {
        classes.push('border-yellow-500')
      } else {
        classes.push('border-gray-200')
      }
    }
  } else {
    if (isSelectedMonth(day)) {
      classes.push('text-gray-900')
    } else {
      classes.push('text-gray-400')
    }
    if (externalDayEnabled(day)) {
      classes.push('bg-blue-600', 'text-white')
      if (dayClosed(day)) {
        classes.push('border-2', 'border-yellow-800')
      }
    } else if (dayClosed(day)) {
      classes.push('bg-yellow-800', 'text-white')
    } else if (arrivalSlots(day).length && !props.externalDays) {
      if (
        arrivalSlots(day).some(
          x =>
            new Date() > new Date(x.attributes.begin_taking_orders) && new Date() < new Date(x.attributes.actual_cutoff)
        )
      ) {
        if (
          arrivalSlots(day).some(
            x => (x.attributes.limit_quantity && x.attributes.quantity_left) || !x.attributes.limit_quantity
          )
        ) {
          classes.push('text-white', 'bg-green-500', 'hover:bg-green-600')
        } else {
          classes.push('text-white', 'bg-red-500', 'hover:bg-red-600')
        }
      } else if (arrivalSlots(day).some(x => new Date() < new Date(x.attributes.begin_taking_orders))) {
        classes.push('text-white', 'bg-yellow-500', 'hover:bg-yellow-600')
      } else {
        classes.push('bg-gray-200', 'text-black')
      }
    } else {
      classes.push('hover:bg-gray-200')
    }
  }
  if (productionSlots(day).length) {
    classes.push('outline', 'outline-offset-2')
    if (
      productionSlots(day).some(
        x =>
          new Date() > new Date(x.attributes.begin_taking_orders) && new Date() < new Date(x.attributes.actual_cutoff)
      )
    ) {
      classes.push('outline-gray-600')
    } else {
      classes.push('outline-gray-300')
    }
  }

  return classes
}

const slots = day =>
  _.uniqBy([...productionSlots(day), ...arrivalSlots(day)], 'id').sort(
    (a, b) => new Date(a.attributes.arrives_beginning_estimate) - new Date(b.attributes.arrives_beginning_estimate)
  )
const productionSlots = day => props.slots.filter(x => x.attributes.fulfillment_date === dateObjectToServerDay(day))
const arrivalSlots = day =>
  props.slots.filter(x => {
    const start = new Date(x.attributes.arrives_beginning_estimate)
    const end = new Date(x.attributes.arrives_ending_estimate)
    day.setHours(0, 0, 0, 0)
    start.setHours(0, 0, 0, 0)
    end.setHours(0, 0, 0, 0)
    return day >= start && day <= end
  })

const method = slot => mapRelationship(slot.relationships?.fulfillment_method?.data)

const methods = computed(() => mapType('fulfillment_method'))
const methodOptions = computed(() => methods.value.map(x => ({ name: x.attributes.name, value: x })))
const hasMethods = computed(() => methods.value.length > 0)
const methodActive = method => {
  if (!method) return false
  const pairs = mapRelationships(props.store?.relationships?.fulfillment_method_store_pairs?.data)
  return pairs.some(x => x.attributes.fulfillment_method_id.toString() === method.id)
}

const closures = computed(() => mapType('store_closure'))
api.call('GET', 'store_closures')

const daySpecificallyClosed = day =>
  closures.value.some(
    x =>
      x.attributes.date === dateObjectToServerDay(day) &&
      (x.attributes.type === 'MerchantStoreClosure' ||
        (x.attributes.type === 'StoreStoreClosure' && x.attributes.related_id == props.store?.id) ||
        (x.attributes.type === 'FulfillmentMethodStoreClosure' &&
          x.attributes.related_id == props.fulfillmentMethod?.id))
  )

const dayClosed = day =>
  daySpecificallyClosed(day) || (slots(day).length && slots(day).every(x => x.attributes.closure_day))

const dayClosedForAllStores = day =>
  closures.value
    .filter(x => x.attributes.date === dateObjectToServerDay(day))
    .some(x => x.attributes.type === 'MerchantStoreClosure')

// The closure just created and the upcoming drops it left with no open date,
// so the merchant can undo it from the warning modal.
const impact = ref({ closureId: null, drops: [] })
const dismissImpact = () => (impact.value = { closureId: null, drops: [] })

const createClosure = async (type, relatedId) => {
  let response
  try {
    response = await api.call('POST', 'store_closures', {
      store_closure: { type, related_id: relatedId, date: dateObjectToServerDay(selectedDay.value) }
    })
  } catch {
    return showToast("Couldn't close ordering for that day. Please try again.", { type: 'error' })
  }
  emit('getSlots', days.value)
  modal.value.closure = false
  impact.value = { closureId: response.data.data.id, drops: affectedDropsFrom(response) }
}

const closeDayForStore = () => createClosure('StoreStoreClosure', props.store.id)

const closeDayForMethod = () => createClosure('FulfillmentMethodStoreClosure', props.fulfillmentMethod.id)

const closeDayForMerchant = () => createClosure('MerchantStoreClosure', store.getters.loggedInUserId)

const undoClosure = async () => {
  const { closureId } = impact.value
  dismissImpact()
  await api.call('DELETE', 'store_closures/' + closureId)
  emit('getSlots', days.value)
}

const closeDay = () => {
  if (props.fulfillmentMethod?.id) modal.value.closure = 'method'
  else if (props.store?.id) modal.value.closure = 'store'
  else closeDayForMerchant()
}

const openDay = async () => {
  await Promise.all(
    closures.value
      .filter(
        x =>
          x.attributes.date === dateObjectToServerDay(selectedDay.value) &&
          (x.attributes.type === 'MerchantStoreClosure' ||
            (x.attributes.type === 'StoreStoreClosure' && x.attributes.related_id == props.store?.id) ||
            (x.attributes.type === 'FulfillmentMethodStoreClosure' &&
              x.attributes.related_id == props.fulfillmentMethod?.id))
      )
      .map(x => api.call('DELETE', 'store_closures/' + x.id))
  )
  emit('getSlots', days.value)
}

const addSlot = () => {
  modal.value.method = false
  const arrival = new Date(selectedDay.value)
  arrival.setHours(12)
  api
    .call(
      'POST',
      `fulfillment_methods/${(modal.value.fulfillmentMethod ?? props.fulfillmentMethod).id}/fulfillment_slots`,
      {
        fulfillment_slot: {
          is_active: false,
          arrives_beginning_estimate: arrival,
          arrives_estimate_setting: 'specific_time',
          date_setting: 'match_arrives_beginning_estimate',
          begin_taking_orders_setting: 'open',
          cutoff_setting: 'match_arrives_beginning_estimate'
        }
      },
      { save: false }
    )
    .then(response => {
      openModal(response.data.data)
      modal.value.new = true
    })
}

const clone = slot => {
  if (!modal.value.clone) {
    modal.value.clone = slot
    modal.value.method = true
    modal.value.fulfillmentMethod = mapRelationship(slot.relationships?.fulfillment_method?.data)
  } else {
    api
      .call(
        'POST',
        `fulfillment_methods/${modal.value.fulfillmentMethod.id}/fulfillment_slots`,
        {
          fulfillment_slot: {
            ...modal.value.clone.attributes,
            is_active: false
          }
        },
        { save: false }
      )
      .then(response => {
        openModal(response.data.data)
        modal.value.new = true
        modal.value.clone = null
      })
  }
}

const toggleExternalDay = () => {
  if (!props.editable) return
  let externalDays = props.externalDays
  if (externalDayEnabled(selectedDay.value)) {
    externalDays = externalDays.filter(x => x !== dateObjectToServerDay(selectedDay.value))
  } else {
    externalDays.push(dateObjectToServerDay(selectedDay.value))
  }
  emit('update:externalDays', externalDays)
}
const externalDayEnabled = day => props.externalDays?.includes(dateObjectToServerDay(day))

const addSplitDay = () => {
  modal.value.splitDays.push({ date: dateObjectToServerDay(modal.value.addingSplitDay) })
}

const deleteSplitDay = day => {
  day._destroy = true
}

const deleteSlot = async chain => {
  modal.value.open = false
  modal.value.delete = false
  if (chain) {
    await api.call(
      'DELETE',
      `fulfillment_methods/${modal.value.slot.relationships.fulfillment_method.data.id}/fulfillment_slots/${modal.value.slot.id}?cascade=true`
    )
    return emit('getSlots', days.value)
  } else {
    return api.call(
      'DELETE',
      `fulfillment_methods/${modal.value.slot.relationships.fulfillment_method.data.id}/fulfillment_slots/${modal.value.slot.id}`
    )
  }
}

const openModal = slot => {
  earliestSelectable.value = new Date()
  const duplicator = mapRelationship(slot.relationships.duplicator.data)

  let repeat
  if (duplicator && duplicator.attributes.interval_type) {
    if (duplicator.attributes.interval_type === 'days') {
      if (duplicator.attributes.interval_days === '12345') {
        repeat = 'weekdays'
      } else {
        repeat = 'custom'
      }
    } else if (duplicator.attributes.interval_type === 'weeks') {
      if (duplicator.attributes.interval_number === 1) {
        repeat = 'weekly'
      } else if (duplicator.attributes.interval_number === 2) {
        repeat = 'biweekly'
      }
    } else if (duplicator.attributes.interval_type === 'months' && duplicator.attributes.interval_number === 1) {
      repeat = 'monthly'
    }
  } else {
    repeat = 'none'
  }
  // if none of these conditions are true, the duplicator status is unknown and we leave the picker blank

  modal.value = {
    slot,
    pickers: {
      arrival: { end: slot.attributes.arrives_estimate_setting !== 'specific_time' },
      production: slot.attributes.date_setting !== 'match_arrives_beginning_estimate',
      ordering: {
        start: slot.attributes.begin_taking_orders_setting !== 'open',
        end: {
          display: slot.attributes.cutoff_setting !== 'match_arrives_beginning_estimate',
          actual: slot.attributes.display_cutoff !== slot.attributes.actual_cutoff
        }
      }
    },
    arrival: {
      start: slot.attributes.arrives_beginning_estimate ? new Date(slot.attributes.arrives_beginning_estimate) : null,
      end: slot.attributes.arrives_ending_estimate ? new Date(slot.attributes.arrives_ending_estimate) : null
    },
    production: slot.attributes.fulfillment_date ? serverDayToDateObject(slot.attributes.fulfillment_date) : null,
    ordering: {
      // An 'open' slot stores a sentinel begin_taking_orders a year in the past.
      start:
        slot.attributes.begin_taking_orders && slot.attributes.begin_taking_orders_setting !== 'open'
          ? new Date(slot.attributes.begin_taking_orders)
          : null,
      end: {
        display: slot.attributes.display_cutoff ? new Date(slot.attributes.display_cutoff) : null,
        actual: slot.attributes.actual_cutoff ? new Date(slot.attributes.actual_cutoff) : null
      }
    },
    repeat,
    days: Array.from({ length: 7 }, (_, i) => duplicator?.attributes.interval_days?.includes(i.toString())),
    inventory: slot.attributes.limit_quantity,
    limit: (slot.attributes.specified_quantity_limit ?? '').toString(),
    // split: slot.attributes.allow_day_splits,
    // splitDays: mapRelationships(slot.relationships.fulfillment_availabilities.data).map(x => ({
    //   id: x.id,
    //   date: x.attributes.date
    // })),
    // addingSplitDay: new Date(),
    left: slot.attributes.quantity_left ?? '∞',
    open: true,
    delete: false,
    save: false,
    method: false,
    closure: false,
    clone: null
  }
}

const saveSlot = chain => {
  api
    .call(
      'PUT',
      `fulfillment_methods/${modal.value.slot.relationships.fulfillment_method.data.id}/fulfillment_slots/${modal.value.slot.id}?included=duplicator,fulfillment_availabilities`,
      {
        fulfillment_slot: {
          is_active: true,

          arrives_beginning_estimate: modal.value.arrival.start,
          arrives_ending_estimate: modal.value.pickers.arrival.end ? modal.value.arrival.end : undefined,
          fulfillment_date: modal.value.pickers.production ? dateObjectToServerDay(modal.value.production) : undefined,
          display_cutoff: modal.value.pickers.ordering.end.display ? modal.value.ordering.end.display : undefined,
          // TODO(alicja): make this ternary less terrible
          actual_cutoff: modal.value.pickers.ordering.end.display
            ? modal.value.pickers.ordering.end.actual
              ? modal.value.ordering.end.actual
              : modal.value.ordering.end.display
            : undefined,
          begin_taking_orders: modal.value.pickers.ordering.start ? modal.value.ordering.start : undefined,

          arrives_estimate_setting: modal.value.pickers.arrival.end ? null : 'specific_time',
          date_setting: modal.value.pickers.production ? null : 'match_arrives_beginning_estimate',
          cutoff_setting: modal.value.pickers.ordering.end.display ? null : 'match_arrives_beginning_estimate',
          begin_taking_orders_setting: modal.value.pickers.ordering.start ? null : 'open',

          duplicator_attributes: chain
            ? {
                through_interval_number: 6,
                through_interval_type: 'months',
                interval_number: 1,
                ...{
                  weekly: { interval_type: 'weeks' },
                  biweekly: { interval_type: 'weeks', interval_number: 2 },
                  weekdays: { interval_type: 'days', interval_days: '12345' },
                  monthly: { interval_type: 'months' },
                  custom: {
                    interval_type: 'days',
                    interval_days: modal.value.days.reduce((acc, x, i) => (x ? acc + i.toString() : acc), '')
                  }
                }[modal.value.repeat]
              }
            : undefined,
          limit_quantity: modal.value.inventory,
          specified_quantity_limit: modal.value.inventory ? modal.value.limit : null
          // allow_day_splits: modal.value.split,
          // fulfillment_availabilities_attributes: modal.value.splitDays
        }
      }
    )
    .then(() => {
      if (chain) emit('getSlots', days.value)
    })
  modal.value.open = false
  modal.value.save = false
}

emit('getSlots', days.value)

return (_ctx, _cache) => {
  const _component_InlineDatePicker = _resolveComponent("InlineDatePicker")
  const _component_FormElement = _resolveComponent("FormElement")
  const _component_NeueToggle = _resolveComponent("NeueToggle")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_InputField = _resolveComponent("InputField")
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheModal, {
      "is-open": modal.value.open,
      "modal-title": modal.value.new ? 'New slot' : 'Edit slot settings',
      onCloseModal: _cache[23] || (_cache[23] = $event => (modal.value.open = false))
    }, {
      main: _withCtx(() => [
        _createVNode(_component_FormSection, { class: "text-sm" }, {
          default: _withCtx(() => [
            _createVNode(_component_FormElement, { class: "mb-2" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(InformationCircleIcon), { class: "h-6 w-6 mr-1.5" }),
                  _createElementVNode("div", _hoisted_2, "All times and dates are in " + _toDisplayString(browserTZ.value), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(CalendarDaysIcon), { class: "h-6 w-6 text-gray-600" })
                  ]),
                  _createElementVNode("div", null, [
                    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "font-medium text-gray-700" }, "Arrival window", -1)),
                    _cache[47] || (_cache[47] = _createElementVNode("p", { class: "mb-3 text-sm text-gray-500" }, "The period of time that the customer can expect delivery in", -1)),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("input", {
                          id: "arrival-1",
                          type: "radio",
                          name: "arrival",
                          class: "mr-2 cursor-pointer",
                          checked: !modal.value.pickers.arrival.end,
                          onInput: _cache[0] || (_cache[0] = $event => (modal.value.pickers.arrival.end = false))
                        }, null, 40, _hoisted_7),
                        _cache[42] || (_cache[42] = _createElementVNode("label", { for: "arrival-1" }, "This slot is at a specific time", -1))
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("input", {
                          id: "arrival-2",
                          type: "radio",
                          name: "arrival",
                          class: "mr-2 cursor-pointer",
                          checked: modal.value.pickers.arrival.end,
                          onInput: enableArrivalRange
                        }, null, 40, _hoisted_9),
                        _cache[43] || (_cache[43] = _createElementVNode("label", { for: "arrival-2" }, "This slot is for a range of time", -1))
                      ])
                    ]),
                    (modal.value.pickers.arrival.end)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _cache[44] || (_cache[44] = _createElementVNode("span", null, "Between", -1)),
                          _createVNode(_component_InlineDatePicker, {
                            modelValue: modal.value.arrival.start,
                            "onUpdate:modelValue": [
                              _cache[1] || (_cache[1] = $event => ((modal.value.arrival.start) = $event)),
                              raiseArrivalEndTo
                            ],
                            mode: "dateTime",
                            "min-date": earliestSelectable.value
                          }, null, 8, ["modelValue", "min-date"]),
                          _cache[45] || (_cache[45] = _createElementVNode("span", null, "and", -1)),
                          _createVNode(_component_InlineDatePicker, {
                            modelValue: modal.value.arrival.end,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((modal.value.arrival.end) = $event)),
                            mode: "dateTime",
                            "min-date": earliestSelectable.value
                          }, null, 8, ["modelValue", "min-date"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_InlineDatePicker, {
                            modelValue: modal.value.arrival.start,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((modal.value.arrival.start) = $event)),
                            mode: "dateTime",
                            "min-date": earliestSelectable.value
                          }, null, 8, ["modelValue", "min-date"])
                        ]))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_FormElement, { class: "mb-2" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(CubeIcon), { class: "h-6 w-6 text-gray-600" })
                  ]),
                  _createElementVNode("div", null, [
                    _cache[50] || (_cache[50] = _createElementVNode("div", { class: "font-medium text-gray-700" }, "Production day", -1)),
                    _cache[51] || (_cache[51] = _createElementVNode("p", { class: "mb-3 text-sm text-gray-500" }, "The day you produce/package/fulfill the order", -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("input", {
                          id: "production-1",
                          type: "radio",
                          name: "production",
                          class: "mr-2 cursor-pointer",
                          checked: !modal.value.pickers.production,
                          onInput: _cache[4] || (_cache[4] = $event => (modal.value.pickers.production = false))
                        }, null, 40, _hoisted_16),
                        _cache[48] || (_cache[48] = _createElementVNode("label", { for: "production-1" }, "Let production day be the same as arrival day", -1))
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("input", {
                          id: "production-2",
                          type: "radio",
                          name: "production",
                          class: "mr-2 cursor-pointer",
                          checked: modal.value.pickers.production,
                          onInput: _cache[5] || (_cache[5] = $event => (modal.value.pickers.production = true))
                        }, null, 40, _hoisted_18),
                        _cache[49] || (_cache[49] = _createElementVNode("label", { for: "production-2" }, "I want to specify the production day", -1))
                      ])
                    ]),
                    (modal.value.pickers.production)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_InlineDatePicker, {
                            modelValue: modal.value.production,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((modal.value.production) = $event)),
                            "min-date": earliestSelectable.value
                          }, null, 8, ["modelValue", "min-date"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_FormElement, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_unref(LockOpenIcon), { class: "h-6 w-6 text-gray-600" })
                  ]),
                  _createElementVNode("div", null, [
                    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "font-medium text-gray-700" }, "Ordering begins", -1)),
                    _cache[55] || (_cache[55] = _createElementVNode("p", { class: "mb-3 text-sm text-gray-500" }, " The time you want customers to be able to start ordering for this production day ", -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("input", {
                          id: "ordering-start-1",
                          type: "radio",
                          name: "ordering-start",
                          class: "mr-2 cursor-pointer",
                          checked: !modal.value.pickers.ordering.start,
                          onInput: _cache[7] || (_cache[7] = $event => (modal.value.pickers.ordering.start = false))
                        }, null, 40, _hoisted_24),
                        _cache[52] || (_cache[52] = _createElementVNode("label", { for: "ordering-start-1" }, "Customers can begin ordering right now", -1))
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("input", {
                          id: "ordering-start-2",
                          type: "radio",
                          name: "ordering-start",
                          class: "mr-2 cursor-pointer",
                          checked: modal.value.pickers.ordering.start,
                          onInput: _cache[8] || (_cache[8] = $event => (modal.value.pickers.ordering.start = true))
                        }, null, 40, _hoisted_26),
                        _cache[53] || (_cache[53] = _createElementVNode("label", { for: "ordering-start-2" }, "Customers can only start placing orders at a specific time", -1))
                      ])
                    ]),
                    (modal.value.pickers.ordering.start)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createVNode(_component_InlineDatePicker, {
                            modelValue: modal.value.ordering.start,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((modal.value.ordering.start) = $event)),
                            mode: "dateTime"
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_FormElement, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_unref(ClockIcon), { class: "h-6 w-6 text-gray-600" })
                  ]),
                  _createElementVNode("div", null, [
                    _cache[60] || (_cache[60] = _createElementVNode("div", { class: "font-medium text-gray-700" }, "Order cutoff time", -1)),
                    _cache[61] || (_cache[61] = _createElementVNode("p", { class: "mb-3 text-sm text-gray-500" }, "The time you want to stop taking orders for this production day", -1)),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("input", {
                          id: "ordering-end-1",
                          type: "radio",
                          name: "ordering-end",
                          class: "mr-2 cursor-pointer",
                          checked: !modal.value.pickers.ordering.end.display,
                          onInput: _cache[10] || (_cache[10] = $event => (modal.value.pickers.ordering.end.display = false))
                        }, null, 40, _hoisted_32),
                        _cache[56] || (_cache[56] = _createElementVNode("label", { for: "ordering-end-1" }, "Customers can order up until the arrival time", -1))
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("input", {
                          id: "ordering-end-2",
                          type: "radio",
                          name: "ordering-end",
                          class: "mr-2 cursor-pointer",
                          checked: modal.value.pickers.ordering.end.display,
                          onInput: _cache[11] || (_cache[11] = $event => (modal.value.pickers.ordering.end.display = true))
                        }, null, 40, _hoisted_34),
                        _cache[57] || (_cache[57] = _createElementVNode("label", { for: "ordering-end-2" }, "Customers can order up until a specific time", -1))
                      ])
                    ]),
                    (modal.value.pickers.ordering.end.display)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _cache[58] || (_cache[58] = _createElementVNode("span", null, "Cutoff shown to customers:", -1)),
                            _createVNode(_component_InlineDatePicker, {
                              modelValue: modal.value.ordering.end.display,
                              "onUpdate:modelValue": [
                                _cache[12] || (_cache[12] = $event => ((modal.value.ordering.end.display) = $event)),
                                raiseHardCutoffTo
                              ],
                              mode: "dateTime",
                              "min-date": earliestSelectable.value
                            }, null, 8, ["modelValue", "min-date"])
                          ]),
                          _createVNode(_component_NeueToggle, {
                            modelValue: modal.value.pickers.ordering.end.actual,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((modal.value.pickers.ordering.end.actual) = $event)),
                            class: "mt-3",
                            name: "Allow orders after cutoff",
                            compact: true,
                            onChange: defaultHardCutoffToDisplayCutoff
                          }, null, 8, ["modelValue"]),
                          (modal.value.pickers.ordering.end.actual)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _cache[59] || (_cache[59] = _createElementVNode("span", null, "Hard order cutoff:", -1)),
                                _createVNode(_component_InlineDatePicker, {
                                  modelValue: modal.value.ordering.end.actual,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((modal.value.ordering.end.actual) = $event)),
                                  mode: "dateTime",
                                  "min-date": earliestSelectable.value
                                }, null, 8, ["modelValue", "min-date"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_FormElement, null, {
              default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                _createElementVNode("hr", { class: "divide-gray-200" }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_FormElement, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_38, [
                  _cache[63] || (_cache[63] = _createElementVNode("div", { class: "text-lg font-medium leading-6 text-gray-900 -mr-2" }, "Repeat", -1)),
                  _createVNode(_component_NeueToggle, {
                    "model-value": modal.value.repeat !== 'none',
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = 
                x => {
                  if (x) modal.value.repeat = 'weekly'
                  else modal.value.repeat = 'none'
                }
              )
                  }, null, 8, ["model-value"])
                ])
              ]),
              _: 1
            }),
            (modal.value.repeat !== 'none')
              ? (_openBlock(), _createBlock(_component_FormElement, {
                  key: 0,
                  class: "-mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectInput, {
                      modelValue: modal.value.repeat,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((modal.value.repeat) = $event)),
                      options: [
              { name: 'Weekly', value: 'weekly' },
              { name: 'Every weekday (Monday to Friday)', value: 'weekdays' },
              { name: 'Bi-weekly (every second week)', value: 'biweekly' },
              { name: 'Monthly', value: 'monthly' },
              { name: 'Custom', value: 'custom' }
            ]
                    }, null, 8, ["modelValue"]),
                    (modal.value.repeat === 'custom')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modal.value.days, (_, day) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass([modal.value.days[day] && 'bg-green-500', "w-10 h-10 bg-gray-600 hover:bg-green-600 rounded-full text-white inline-flex justify-center items-center mr-2 cursor-pointer"]),
                              onClick: $event => (modal.value.days[day] = !modal.value.days[day])
                            }, _toDisplayString(['S', 'M', 'T', 'W', 'T', 'F', 'S'][day]), 11, _hoisted_40))
                          }), 256))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_FormElement, null, {
              default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                _createElementVNode("hr", { class: "divide-gray-200" }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_FormElement, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_41, [
                  _cache[65] || (_cache[65] = _createElementVNode("div", { class: "text-lg font-medium leading-6 text-gray-900 -mr-2" }, "Inventory and availability", -1)),
                  _createVNode(_component_NeueToggle, {
                    modelValue: modal.value.inventory,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ((modal.value.inventory) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            (modal.value.inventory)
              ? (_openBlock(), _createBlock(_component_FormElement, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputField, {
                      modelValue: modal.value.limit,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((modal.value.limit) = $event)),
                      name: "Order limit",
                      description: `Limit the number of orders for this slot (${modal.value.left} orders left)`,
                      onInput: _cache[19] || (_cache[19] = () => (modal.value.limit = modal.value.limit.replace(/\D/g, '')))
                    }, null, 8, ["modelValue", "description"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_FormElement, null, {
              default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                _createElementVNode("hr", { class: "divide-gray-200" }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          (!modal.value.new)
            ? (_openBlock(), _createBlock(NeueButton, {
                key: 0,
                type: "red",
                onClick: _cache[20] || (_cache[20] = $event => (modal.value.delete = true))
              }, {
                default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                  _createTextVNode("Delete", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(NeueButton, {
            type: "secondary",
            onClick: _cache[21] || (_cache[21] = $event => (modal.value.open = false))
          }, {
            default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          _createVNode(NeueButton, {
            type: "primary",
            onClick: _cache[22] || (_cache[22] = $event => (modal.value.repeat !== 'none' && !modal.value.new ? (modal.value.save = true) : saveSlot(true)))
          }, {
            default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
              _createTextVNode(" Save ", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["is-open", "modal-title"]),
    _createVNode(_component_TheModal, {
      "is-open": modal.value.delete,
      "modal-title": "Delete slot?",
      "footer-full-width": true,
      onCloseModal: _cache[27] || (_cache[27] = $event => (modal.value.delete = false))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_43, [
          _createVNode(NeueButton, {
            type: "secondary",
            onClick: _cache[24] || (_cache[24] = $event => (modal.value.delete = false))
          }, {
            default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_44, [
            _createVNode(NeueButton, {
              type: "red",
              onClick: _cache[25] || (_cache[25] = $event => (deleteSlot(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Delete " + _toDisplayString(modal.value.repeat !== 'none' ? 'this slot only' : ''), 1)
              ]),
              _: 1
            }),
            (modal.value.repeat !== 'none')
              ? (_openBlock(), _createBlock(NeueButton, {
                  key: 0,
                  type: "red",
                  onClick: _cache[26] || (_cache[26] = $event => (deleteSlot(true)))
                }, {
                  default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                    _createTextVNode(" Delete this and all future slots ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_TheModal, {
      "is-open": modal.value.save,
      "modal-title": "Save slot?",
      onCloseModal: _cache[31] || (_cache[31] = $event => (modal.value.save = false))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_45, [
          _createVNode(NeueButton, {
            type: "secondary",
            onClick: _cache[28] || (_cache[28] = $event => (modal.value.save = false))
          }, {
            default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(NeueButton, {
              type: "primary",
              onClick: _cache[29] || (_cache[29] = $event => (saveSlot(false)))
            }, {
              default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                _createTextVNode("Save this slot only", -1)
              ]))]),
              _: 1
            }),
            (modal.value.repeat !== 'none')
              ? (_openBlock(), _createBlock(NeueButton, {
                  key: 0,
                  type: "primary",
                  onClick: _cache[30] || (_cache[30] = $event => (saveSlot(true)))
                }, {
                  default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                    _createTextVNode(" Save this and all future slots ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_TheModal, {
      "is-open": modal.value.method,
      "modal-title": "Select fulfillment method",
      onCloseModal: _cache[35] || (_cache[35] = $event => ((modal.value.method = false), (modal.value.clone = null)))
    }, {
      main: _withCtx(() => [
        _createVNode(_component_SelectInput, {
          modelValue: modal.value.fulfillmentMethod,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => ((modal.value.fulfillmentMethod) = $event)),
          options: methodOptions.value,
          disabled: !hasMethods.value,
          placeholder: hasMethods.value ? 'Select a fulfillment method' : 'No active fulfillment methods',
          description: hasMethods.value ? undefined : 'Create or enable a fulfillment method first.'
        }, null, 8, ["modelValue", "options", "disabled", "placeholder", "description"]),
        (!hasMethods.value && _unref(wizardEnabled))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "mt-2 inline-block text-sm font-medium text-brand-600 hover:underline",
              to: { path: _unref(WIZARD_PATH), query: props.store ? { store: props.store.id } : {} }
            }, {
              default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                _createTextVNode(" Create a fulfillment method ", -1)
              ]))]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (modal.value.fulfillmentMethod && props.store && !methodActive(modal.value.fulfillmentMethod))
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _createVNode(_unref(ExclamationTriangleIcon), { class: "h-8 w-8 mr-2 text-orange-400 flex-shrink-0" }),
              _cache[76] || (_cache[76] = _createElementVNode("div", null, [
                _createElementVNode("div", { class: "font-medium" }, "This fulfillment method is not enabled"),
                _createElementVNode("div", { class: "text-gray-500" }, " Turn on the fulfillment method for this store in order to make the method's slots active and visible during checkout ")
              ], -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_48, [
          _createVNode(NeueButton, {
            type: "secondary",
            onClick: _cache[33] || (_cache[33] = $event => (modal.value.method = false))
          }, {
            default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          _createVNode(NeueButton, {
            type: modal.value.fulfillmentMethod ? 'primary' : 'inactive',
            onClick: _cache[34] || (_cache[34] = $event => (modal.value.clone ? clone() : addSlot()))
          }, {
            default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
              _createTextVNode(" Select ", -1)
            ]))]),
            _: 1
          }, 8, ["type"])
        ])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_TheModal, {
      "is-open": modal.value.closure !== false,
      "modal-title": 'Close ordering for ' + _unref(monthDayFormat)(selectedDay.value),
      onCloseModal: _cache[37] || (_cache[37] = $event => (modal.value.closure = false))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createVNode(NeueButton, {
            type: "secondary",
            onClick: _cache[36] || (_cache[36] = $event => (modal.value.closure = false))
          }, {
            default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          (modal.value.closure === 'store')
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createVNode(NeueButton, {
                  type: "primary",
                  onClick: closeDayForMerchant
                }, {
                  default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                    _createTextVNode("Close all stores", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(NeueButton, {
                  type: "primary",
                  onClick: closeDayForStore
                }, {
                  default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
                    _createTextVNode("Close this store", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (modal.value.closure === 'method')
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createVNode(NeueButton, {
                  type: "primary",
                  onClick: closeDayForMerchant
                }, {
                  default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                    _createTextVNode("Close all fulfillment methods", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(NeueButton, {
                  type: "primary",
                  onClick: closeDayForMethod
                }, {
                  default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                    _createTextVNode("Close this fulfillment method", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["is-open", "modal-title"]),
    _createVNode(DropImpactWarningModal, {
      "is-open": impact.value.drops.length > 0,
      "affected-drops": impact.value.drops,
      "action-noun": "closure",
      onUndo: undoClosure,
      onKeep: dismissImpact
    }, null, 8, ["is-open", "affected-drops"]),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("h2", {
            class: "flex-auto text-sm font-semibold text-gray-900 cursor-pointer",
            onClick: _cache[38] || (_cache[38] = 
            () => {
              selectedDay.value = new Date()
              emit('getSlots', days.value)
            }
          )
          }, _toDisplayString(_unref(monthFormat)(selectedDay.value)), 1),
          _createElementVNode("button", {
            type: "button",
            class: "-my-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500",
            onClick: _cache[39] || (_cache[39] = 
            () => {
              selectedDay.value = plusMonths(selectedDay.value, -1)
              emit('getSlots', days.value)
            }
          )
          }, [
            _cache[84] || (_cache[84] = _createElementVNode("span", { class: "sr-only" }, "Previous month", -1)),
            _createVNode(_unref(ChevronLeftIcon), {
              class: "h-5 w-5",
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "-my-1.5 -mr-1.5 ml-2 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500",
            onClick: _cache[40] || (_cache[40] = 
            () => {
              selectedDay.value = plusMonths(selectedDay.value, 1)
              emit('getSlots', days.value)
            }
          )
          }, [
            _cache[85] || (_cache[85] = _createElementVNode("span", { class: "sr-only" }, "Next month", -1)),
            _createVNode(_unref(ChevronRightIcon), {
              class: "h-5 w-5",
              "aria-hidden": "true"
            })
          ])
        ]),
        _cache[86] || (_cache[86] = _createElementVNode("div", { class: "mt-10 grid grid-cols-7 text-center text-xs leading-6 text-gray-500" }, [
          _createElementVNode("div", null, "S"),
          _createElementVNode("div", null, "M"),
          _createElementVNode("div", null, "T"),
          _createElementVNode("div", null, "W"),
          _createElementVNode("div", null, "T"),
          _createElementVNode("div", null, "F"),
          _createElementVNode("div", null, "S")
        ], -1)),
        _createElementVNode("div", _hoisted_55, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: day,
              class: _normalizeClass(["py-2", i > 6 && 'border-t border-gray-200'])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["mx-auto flex h-8 w-8 items-center justify-center rounded-full", dayClasses(day)]),
                onClick: $event => (selectedDay.value = day)
              }, _toDisplayString(_unref(calendarFormat)(day)), 11, _hoisted_56)
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_57, [
        (props.externalDays && !externalDayEnabled(selectedDay.value) && __props.editable)
          ? (_openBlock(), _createBlock(NeueButton, {
              key: 0,
              class: "mb-2",
              onClick: toggleExternalDay
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Select " + _toDisplayString(_unref(monthDayFormat)(selectedDay.value)), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("h2", _hoisted_58, " Fulfillment slots for " + _toDisplayString(_unref(monthDayFormat)(selectedDay.value)), 1),
        _createElementVNode("div", _hoisted_59, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slots(selectedDay.value), (slot) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["group w-full rounded-lg border border-gray-400 overflow-hidden shadow-sm", [
            daySpecificallyClosed(selectedDay.value) && 'opacity-50',
            __props.editable ? 'cursor-pointer hover:bg-gray-50 hover:shadow-md' : ''
          ]]),
              onClick: $event => (__props.editable && openModal(slot))
            }, [
              (!props.fulfillmentMethod && method(slot))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: '/store/fulfillment-methods/' + method(slot)?.id,
                    class: "block mb-1 font-manrope uppercase tracking-wider text-sm text-gray-900 border-b px-3 py-1.5 bg-gray-50 group-hover:bg-gray-100 break-words"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(method(slot)?.attributes?.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (!props.fulfillmentMethod && method(slot))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(method(slot)?.attributes?.name), 1))
                  : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_62, [
                (slot.attributes.limit_quantity)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (slot.attributes.quantity_left)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(slot.attributes.quantity_left) + " order" + _toDisplayString(slot.attributes.quantity_left === 1 ? '' : 's') + " left ", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_64, " Sold out "))
                    ], 64))
                  : _createCommentVNode("", true),
                (slot.attributes.closure_day)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_65, " Ordering closed "))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (new Date() < new Date(slot.attributes.begin_taking_orders))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_66, " Ordering will start " + _toDisplayString(shortFormat(slot.attributes.begin_taking_orders)), 1))
                        : _createCommentVNode("", true),
                      (
                  new Date() > new Date(slot.attributes.begin_taking_orders) &&
                  new Date() < new Date(slot.attributes.actual_cutoff)
                )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_67, " Ordering open until " + _toDisplayString(shortFormat(slot.attributes.actual_cutoff)), 1))
                        : _createCommentVNode("", true),
                      (new Date() > new Date(slot.attributes.actual_cutoff))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_68, " Ordering cutoff was " + _toDisplayString(shortFormat(slot.attributes.actual_cutoff)), 1))
                        : _createCommentVNode("", true)
                    ], 64))
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", null, [
                    _cache[87] || (_cache[87] = _createElementVNode("div", { class: "font-manrope text-gray-600 text-xs" }, "Arrival window", -1)),
                    _createElementVNode("div", _hoisted_71, [
                      (slot.attributes.arrives_beginning_estimate !== slot.attributes.arrives_ending_estimate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_72, [
                            (
                        dateFormat(slot.attributes.arrives_beginning_estimate) !==
                        dateFormat(slot.attributes.arrives_ending_estimate)
                      )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(dateFormat(slot.attributes.arrives_beginning_estimate)) + " at " + _toDisplayString(timeFormat(slot.attributes.arrives_beginning_estimate)) + " - " + _toDisplayString(dateFormat(slot.attributes.arrives_ending_estimate)) + " at " + _toDisplayString(timeFormat(slot.attributes.arrives_ending_estimate)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(dateFormat(slot.attributes.arrives_beginning_estimate)) + " from " + _toDisplayString(timeFormat(slot.attributes.arrives_beginning_estimate)) + " - " + _toDisplayString(timeFormat(slot.attributes.arrives_ending_estimate)), 1))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(dateFormat(slot.attributes.arrives_beginning_estimate)) + " at " + _toDisplayString(timeFormat(slot.attributes.arrives_beginning_estimate)), 1))
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[88] || (_cache[88] = _createElementVNode("div", { class: "font-manrope text-gray-600 text-xs" }, "Production day", -1)),
                    _createElementVNode("div", null, _toDisplayString(dateFormat(_unref(serverDayToDateObject)(slot.attributes.fulfillment_date))), 1)
                  ])
                ]),
                (__props.editable)
                  ? (_openBlock(), _createBlock(NeueButton, {
                      key: 0,
                      type: "secondary",
                      class: "mb-2 sm:mr-2 ml-2",
                      onClick: _withModifiers($event => (clone(slot)), ["stop"])
                    }, {
                      default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                        _createTextVNode(" Duplicate slot ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_60))
          }), 256)),
          (!slots(selectedDay.value).length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["italic", daySpecificallyClosed(selectedDay.value) && 'opacity-50'])
              }, " No slots for this day ", 2))
            : _createCommentVNode("", true),
          (__props.editable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                _createVNode(NeueButton, {
                  type: "primary",
                  onClick: _cache[41] || (_cache[41] = $event => (props.fulfillmentMethod ? addSlot() : (modal.value.method = true)))
                }, {
                  default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                    _createTextVNode(" + Slot ", -1)
                  ]))]),
                  _: 1
                }),
                (!daySpecificallyClosed(selectedDay.value))
                  ? (_openBlock(), _createBlock(NeueButton, {
                      key: 0,
                      type: "secondary",
                      onClick: closeDay
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Close ordering for " + _toDisplayString(_unref(monthDayFormat)(selectedDay.value)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (daySpecificallyClosed(selectedDay.value))
                  ? (_openBlock(), _createBlock(NeueButton, {
                      key: 1,
                      type: "secondary",
                      onClick: openDay
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Reopen ordering for " + _toDisplayString(dayClosedForAllStores(selectedDay.value) ? (props.store?.id ? 'all stores on' : 'all methods on') : '') + " " + _toDisplayString(_unref(monthDayFormat)(selectedDay.value)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

}